import { useTranslation } from 'react-i18next';

import { BlockingReasonRow } from './BlockingReasonRow';
import { BlockingReasonAction, BlockingReasonVariant } from './_types';
import { blockingReasonTranslationKey } from './blockingReasonTranslationKey';

export function RequiredDocumentReason({
  actions,
  unsignedDocumentCount = 1,
  resolved = false,
  variant = 'checkin',
}: {
  actions?: BlockingReasonAction[];
  unsignedDocumentCount?: number;
  resolved?: boolean;
  variant?: BlockingReasonVariant;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });
  const count = Math.max(unsignedDocumentCount, 1);

  return (
    <BlockingReasonRow
      title={t(blockingReasonTranslationKey(variant, 'waiverRequired', 'title'), {
        count,
      })}
      message={t(
        blockingReasonTranslationKey(variant, 'waiverRequired', 'message')
      )}
      actions={resolved ? undefined : actions}
      color={resolved ? 'success' : 'error'}
    />
  );
}
